/**
 * Org omnibox query parser (mirrors API org-search-query.ts).
 */

const FILTER_ALIASES = [
  { re: /^(member|people)\s*:\s*/i, filter: "people" },
  { re: /^team\s*:\s*/i, filter: "teams" },
  { re: /^content\s*:\s*/i, filter: "content" },
  { re: /^channel\s*:\s*/i, filter: "channels" },
  { re: /^file\s*:\s*/i, filter: "files" },
  { re: /^message\s*:\s*/i, filter: "messages" },
  { re: /^in\s*:\s*chat(?:\s+|$)/i, filter: "messages" },
];

function stripQuotes(text) {
  const t = String(text || "").trim();
  const m = t.match(/^"([^"]*)"$/);
  if (m) {
    return { text: m[1].trim(), phrase: true };
  }
  if (t.startsWith('"') && t.endsWith('"') && t.length >= 2) {
    return { text: t.slice(1, -1).trim(), phrase: true };
  }
  return { text: t, phrase: false };
}

export function parseOrgSearchQuery(rawInput) {
  const raw = String(rawInput || "").trim();
  if (!raw) {
    return { raw: "", filter: null, text: "", phrase: false };
  }

  let rest = raw;
  let filter = null;

  for (const { re, filter: f } of FILTER_ALIASES) {
    const m = rest.match(re);
    if (m) {
      filter = f;
      rest = rest.slice(m[0].length);
      break;
    }
  }

  const { text, phrase } = stripQuotes(rest);
  return { raw, filter, text, phrase };
}

export const ORG_SEARCH_PLACEHOLDER = "Search this org…";

/** Rows for the search-help tooltip (prefix → what it finds). */
export const ORG_SEARCH_SYNTAX = [
  { prefix: "member:", meaning: "People" },
  { prefix: "team:", meaning: "Teams" },
  { prefix: "content:", meaning: "Posts, cards, comments" },
  { prefix: "channel:", meaning: "Channels" },
  { prefix: "file:", meaning: "Files" },
  { prefix: "message:", meaning: "Chat messages" },
  { prefix: "in:chat", meaning: "Same as message:" },
  { prefix: '"phrase"', meaning: "Exact phrase" },
];

export const ORG_SEARCH_GROUP_ORDER = [
  "people",
  "teams",
  "posts",
  "cards",
  "comments",
  "channels",
  "files",
  "messages",
];

export const ORG_SEARCH_GROUP_LABELS = {
  people: "People",
  teams: "Teams",
  posts: "Posts",
  cards: "Cards",
  comments: "Comments",
  channels: "Channels",
  files: "Files",
  messages: "Messages",
};

/** Flatten grouped hits in display order. */
export function flattenOrgSearchHits(groups) {
  const out = [];
  for (const key of ORG_SEARCH_GROUP_ORDER) {
    const list = groups?.[key];
    if (Array.isArray(list)) out.push(...list);
  }
  return out;
}
